import Http from './http';



// export interface CardData {
//   security_code: string;
//   card_number: string;
//   expiration_year: number;
//   expiration_month: number;
//   cardholder: CardHolder;
// }

// export interface CardHolder {
//   identification: Identification;
//   name: string;
// }

// interface Identification {
//   number: string;
//   type: string;
// }


export const pauseSubscription = ({
  subscriptionId
}) => {
  console.log({subscriptionId});

  return Http.post('pauseSubscription', {
    subscriptionId
  });
};

export const createPendingSubscription = ({
  planId,
  payerEmail
}) => Http.post('createPreSubscription', {
  planId,
  payerEmail
});

export const createSubscription = ({
  cardData,
  planId,
  payerEmail
}) => Http.post('createSubscriptionProd', {
  cardData,
  planId,
  payerEmail
});


